export const punishmentData = {
    my: {
        title: "ဒဏ်ထမ်းခြင်းစနစ်",
        subtitle: "သီလစင်ကြယ်ရေးအတွက် ထူးခြားသောစနစ်",
        sections: [
            {
                title: "ညဘက်ဒဏ်တောင်းခြင်း",
                content: "မဟာဝိဟာရကျောင်းတိုက်ဝယ် ညဘက် ဘုရားဝတ်တက် ဩဝါဒအပြီး ၇-နာရီခွဲ ကျော်ကျော်မှစ၍ ဆရာတော်၏အဆောင်ရှေ့ ၌ ကိုရင်ကြီး, ကိုရင်လတ်, ကိုရင်ငယ်များ တန်းစီနေ ကြသည်ကို တွေ့မြင်နိုင်သည်။ သီလချိုးဖျက်မိသော သာမဏေများသည် မိမိတို့ သဒ္ဓါတရားအလျောက် လာရောက်ဒဏ်တောင်းကြခြင်း ဖြစ်၏။",
                punishments: [
                    "တရားထိုင်ခြင်း",
                    "အမှိုက်ကောက်ခြင်း",
                    "သစ်ပင်ရေလောင်းခြင်း",
                    "မြက်ကပ္ပိ (မြတ်နှုတ်)ခြင်း"
                ]
            },
            {
                title: "အချိန်မရွေး ဒဏ်တောင်းခွင့်",
                content: "ထိုအချိန်သာမကဘဲ အခြားသော အချိန်တွင်လည်း နာယကဆရာတော်များထံ လာရောက်ပြီး မိမိတို့ အပြစ်များကို ရိုးသားစွာ ဝန်ခံလျက် ဒဏ်တောင်းခြင်း၊ သီလယူခြင်းများကို ပြုလုပ်လေ့ရှိ၏။"
            },
            {
                title: "သံဃာအသစ်များအတွက်",
                content: "ရောက်ခါစ သံဃာအသစ်များလည်း မဟာဝိဟာရသို့ မရောက်မီ အခြားကျောင်းများ၌ နေထိုင်စဉ်က ပြုလုပ်ခဲ့သော အပြစ်များရှိလျှင် မိမိတို့၏ သဒ္ဓါတရားအလျောက် ရိုးသားစွာ ဝန်ခံလျက် သီလစင်ကြယ် စေရန် ဒဏ်ထမ်းခြင်း၊ သီလယူခြင်းများကို ပြုလုပ်ကြရ၏။"
            }
        ],
        conclusion: "ဤသည်မှာလည်း မဟာဝိဟာရ၏ ထူးခြားသော အုပ်ချုပ်ရေးစနစ်တစ်ခု ဖြစ်၏။"
    },
    en: {
        title: "Disciplinary System",
        subtitle: "A Unique System for Moral Purification",
        sections: [
            {
                title: "Evening Disciplinary Practice",
                content: "At Mahãvihãra Monastery, after the evening prayer and sermon around 7:30 PM, one can observe novice monks of all levels lining up in front of the master's residence. These are novices who have broken precepts and come forward voluntarily, driven by their faith, to seek disciplinary actions.",
                punishments: [
                    "Meditation practice",
                    "Cleaning grounds",
                    "Watering trees",
                    "Cutting grass"
                ]
            },
            {
                title: "Open Access for Purification",
                content: "Beyond these designated times, novices can approach the head monks at any time to honestly confess their transgressions and seek disciplinary measures or renew their precepts."
            },
            {
                title: "New Residents' Purification",
                content: "Newly arrived monks who may have committed transgressions at their previous monasteries before joining Mahãvihãra are encouraged to voluntarily confess and undergo disciplinary measures to purify their precepts, guided by their faith and sincerity."
            }
        ],
        conclusion: "This represents another unique aspect of Mahãvihãra's administrative system."
    }
};